export default __webpack_public_path__ + "static/media/login-v2.1910a1b0.png";